import {createFileRoute} from '@tanstack/react-router';
import {LandingPage} from 'pages';

export const Route = createFileRoute('/')({
  component: LandingPage,
  validateSearch: (search): {country?: string; language?: string} => {
    return {
      country: search?.country as string | undefined,
      language: search?.language as string | undefined,
    };
  },
});
